import styled from "styled-components";

export const StyledWrapper = styled.div`
  ${({ theme }) => theme.fontStyles.DesktopLargeBodyCopy}

  .contest-company {
    color: ${({ theme }) => theme.colors.primarySeparator};
    ${({ theme }) => theme.fontStyles.InterfaceCopyXSmall}

    img {
      height: 22px;
    }

    .contest-company-name {
      font-weight: 700;
      color: ${({ theme }) => theme.colors.neutralsText};
    }
  }

  .contest-criteria {
    ${({ theme }) => theme.fontStyles.DesktopLargeBodyCopy}

    ul {
      color: ${({ theme }) => theme.colors.primaryText};
      ${({ theme }) => theme.fontStyles.DesktopCopyLargeBodyCopyBold}

      ${({ theme }) => theme.media.exceptMobile`
        ${({ theme }) => theme.fontStyles.DesktopHeadlinesH5}
      `}
    }
  }

  .contest-divider {
    width: 100%;
    height: 4px;
    color: ${({ theme }) => theme.colors.primarySeparator};
    background-color: ${({ theme }) => theme.colors.primarySeparator};
    border-radius: 2px;
    opacity: 1;
  }

  .contest-heading {
    color: ${({ theme }) => theme.colors.primaryText};
    ${({ theme }) => theme.fontStyles.MobileHeadlinesH3}

    ${({ theme }) => theme.media.exceptMobile`
      ${({ theme }) => theme.fontStyles.DesktopHeadlinesH3}
    `}
  }

  .contest-image {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    aspect-ratio: 1.5;
    border-radius: 8px;
    overflow: hidden;

    img {
      min-width: 100%;
      min-height: 100%;
      flex-shrink: 0;
    }

    .contest-bookmark-image-icon {
      position: absolute;
      top: 0;
      right: 0;
      width: 40px;
      height: 40px;
      background-color: ${({ theme }) =>
        theme.colors.neutralsBackgroundInactive};
      border: 0;
      cursor: pointer;

      &.enabled {
        cursor: cell;
      }
    }

    .contest-image-text {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      text-align: center;
      background-color: rgba(0, 0, 0, 0.6);
    }

    .contest-image-video-icon {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      color: ${({ theme }) => theme.colors.neutralsWhite};
      display: flex;

      .fa-play {
        left: 5px;
      }

      .fa-stack {
        margin: auto;
      }
    }
  }

  .contest-materials {
    color: ${({ theme }) => theme.colors.primaryText};
    ${({ theme }) => theme.fontStyles.DesktopCopyLargeBodyCopyBold}

    ${({ theme }) => theme.media.exceptMobile`
      ${({ theme }) => theme.fontStyles.DesktopHeadlinesH5}
    `}

    img {
      margin: 0 0 2px 2px;
      width: 14px;
      height: 14px;

      ${({ theme }) => theme.media.exceptMobile`
        width: 16px;
        height: 16px;
      `}
    }
  }

  .contest-status {
    .badge {
      color: ${({ theme }) => theme.colors.neutralsWhite};
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      text-transform: capitalize;
      background-color: ${({ theme }) => theme.colors.primarySeparator};
      border-radius: 12px;
    }
  }

  .contest-status-active {
    .contest-divider {
      color: ${({ theme }) => theme.colors.secondaryBackground};
      background-color: ${({ theme }) => theme.colors.secondaryBackground};
    }

    .contest-status {
      .badge {
        background-color: ${({ theme }) => theme.colors.secondaryBackground};
      }
    }
  }

  .contest-status-closing_soon {
    .contest-divider {
      color: ${({ theme }) => theme.colors.atRiskBackground};
      background-color: ${({ theme }) => theme.colors.atRiskBackground};
    }

    .contest-status {
      .badge {
        background-color: ${({ theme }) => theme.colors.atRiskBackground};
      }
    }
  }

  .contest-status-completed {
    .contest-divider {
      color: ${({ theme }) => theme.colors.offTrackBackground};
      background-color: ${({ theme }) => theme.colors.offTrackBackground};
    }

    .contest-status {
      .badge {
        background-color: ${({ theme }) => theme.colors.offTrackBackground};
      }
    }
  }

  .contest-status-new {
    .contest-divider {
      color: ${({ theme }) => theme.colors.primaryTextHover};
      background-color: ${({ theme }) => theme.colors.primaryTextHover};
    }

    .contest-status {
      .badge {
        background-color: ${({ theme }) => theme.colors.primaryTextHover};
      }
    }
  }

  .contest-status-reviewing {
    .contest-divider {
      color: ${({ theme }) => theme.colors.actionBackgroundSelected};
      background-color: ${({ theme }) => theme.colors.actionBackgroundSelected};
    }

    .contest-status {
      .badge {
        background-color: ${({ theme }) =>
          theme.colors.actionBackgroundSelected};
      }
    }
  }

  .contest-title {
    color: ${({ theme }) => theme.colors.primaryText};
    ${({ theme }) => theme.fontStyles.DesktopHeadlinesH3}
  }

  .contest-unavailable {
    color: ${({ theme }) => theme.colors.neutralsText};
    ${({ theme }) => theme.fontStyles.DesktopLargeBodyCopy}
    background-color: ${({ theme }) => theme.colors.neutralsWhite};
    border-left: 6px solid ${({ theme }) => theme.colors.offTrackBackground};
    border-radius: 4px;
  }
`;
